import axios, { AxiosRequestConfig } from 'axios';

const client = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 30_000
});

export const configureClient = () => {
    client.interceptors.request.use(
        (config: AxiosRequestConfig) => {
            config.headers['Cache-Control'] = 'no-cache';
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );
};

export default client;



// WEBPACK FOOTER //
// ./src/api/client.ts